import React from "react";
import { Container, Row } from "react-bootstrap";
import Image from "./img/no-shared.svg";
import { useTranslation } from "react-i18next";

const NoShared: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="noShareContainer rounded-1 bg-white mt-4">
      <Container>
        <Row>
          <div className="text-dark-gray text-center">
            <div className="d-flex flex-column justify-content-center align-items-center mb-5">
              <img
                src={Image}
                width={267}
                className="img-fluid"
                loading="lazy"
                alt="No Projects"
              />
            </div>
            <h4 className="mb-2 fs-3 text-capitalize">
              {t("share.noSharedTitle")}
            </h4>
            <p className="text-gray mx-auto mb-5 fs-6">
              {t("share.noSharedDescription")}
            </p>
          </div>
        </Row>
      </Container>
    </div>
  );
};

export default NoShared;
